const ALL = 'ALL';
const PARTIAL = 'PARTIAL';
const NONE = 'NONE';

export const confectionContractType = {
  ALL,
  PARTIAL,
  NONE,
};

export const confectionType = {
  APP: 'app',
  LAYOUT: 'layout',
  PACKAGING: 'packaging',
  PERSONALIZED: 'personalized',
};
